import { render, staticRenderFns } from "./outorder.vue?vue&type=template&id=73dfa2ac&scoped=true&"
import script from "./outorder.vue?vue&type=script&lang=js&"
export * from "./outorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dfa2ac",
  null
  
)

export default component.exports